import tokens from '@kluein/design-tokens';
import { Loader, Stack, Text } from '@mantine/core';

import type { KlueSpinnerProps } from './KlueSpinner.types';
import type { ReactNode } from 'react';

/**
 * Map klue-ui size keywords to CSS widths.
 * Values sourced from klue-ui theme.global.size (theme.tsx).
 * Consumers pass these as the `width` prop for container sizing.
 */
const KLUE_UI_WIDTH_MAP: Record<string, string> = {
  xxsmall: '20px',
  xsmall: '40px',
  small: '80px',
  medium: '220px',
  large: '320px',
  xlarge: '400px',
  xxlarge: '480px',
  xxxlarge: '600px',
  full: '100%',
};

const resolveWidth = (width: string | undefined): string | undefined => {
  if (!width) return undefined;
  return KLUE_UI_WIDTH_MAP[width] ?? width;
};

const KlueSpinner = ({
  width = 'medium',
  color = tokens.color.primary.main,
  title,
  subtitle,
  size = 50,
}: KlueSpinnerProps): ReactNode => (
  <Stack
    align="center"
    gap="sm"
    w={resolveWidth(width)}
    data-chromatic="ignore"
  >
    <Loader size={size} color={color} />
    {title && (
      <Text ta="center" size="lg" fw={500} c="black">
        {title}
      </Text>
    )}
    {subtitle && (
      <Text ta="center" size="lg">
        {subtitle}
      </Text>
    )}
  </Stack>
);

export default KlueSpinner;
